var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":_vm.$formatId(_vm.slice.id)}})
}
var staticRenderFns = []

export { render, staticRenderFns }